import React, { useState, useEffect, useRef } from 'react';
import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card.js';
import * as d3 from 'd3';
import axios from 'axios';

export default function Conversion(props) {
  const { ...rest } = props;

  // Chakra Color Mode
  const cardColor = useColorModeValue('white', 'navy.700');
  const cardShadow = useColorModeValue(
    '0px 18px 40px rgba(112, 144, 176, 0.12)',
    'unset'
  );

  const [imageBase64, setImageBase64] = useState("");
  const [error, setError] = useState(null); // Initialize error state

  const data = [
    { time: 1, status: 1, kmEstimate: 0.95, lowerCI: 0.90, upperCI: 0.98 },
    { time: 2, status: 0, kmEstimate: 0.92, lowerCI: 0.86, upperCI: 0.95 },
    { time: 3, status: 1, kmEstimate: 0.88, lowerCI: 0.81, upperCI: 0.92 },
    { time: 4, status: 0, kmEstimate: 0.85, lowerCI: 0.77, upperCI: 0.89 },
    { time: 5, status: 1, kmEstimate: 0.80, lowerCI: 0.71, upperCI: 0.85 },
    // ... Add more data points as necessary
  ];

  const width = 400;
  const height = 300;
  const margin = { top: 20, right: 20, bottom: 30, left: 50 };

  const ref = useRef();


  useEffect(() => {
    // Check if selectedOption is not null and has a value field
    if (props.selectedOption && props.selectedOption.value) {
      // Use the selectedOption.value in the API URL
      //   const apiUrl = `http://localhost:8000/api/get-survival-overall-KMC/?project=${props.selectedOption.value}`;
      // const apiUrl = `http://localhost:8000/api/get-crosstalk-enrichment/?project=${props.selectedOption.value}`;
      // const api_host = "http://glycopeptideatlas-eb-env.eba-zxebtsmp.us-west-2.elasticbeanstalk.com"
      // const apiUrl = `${api_host}/api/get-survival-overall-KMC/?project=${props.selectedOption.value}`;


      // axios.get(apiUrl)
      //   .then(response => {
      //     setImageBase64(response.data.image_base64);
      //   })
      //   .catch(err => {
      //     setError("Failed to fetch image."); // Set error state
      //     console.error("Error fetching image: ", err);
      //   });

      const svg = d3.select(ref.current);

      // Define scales
      const x = d3.scaleLinear()
        .domain([0, d3.max(data, d => d.time)])
        .range([margin.left, width - margin.right]);

      const y = d3.scaleLinear()
        .domain([0, 1])
        .range([height - margin.bottom, margin.top]);

      // Plot the KM curve
      const line = d3.line()
        .defined(d => !isNaN(d.kmEstimate))
        .x(d => x(d.time))
        .y(d => y(d.kmEstimate));

      svg.append("path")
        .datum(data)
        .attr("fill", "none")
        .attr("stroke", "steelblue")
        .attr("stroke-width", 1.5)
        .attr("stroke-linejoin", "round")
        .attr("stroke-linecap", "round")
        .attr("d", line);

      // Plot confidence intervals
      const area = d3.area()
        .x(d => x(d.time))
        .y0(d => y(d.lowerCI))
        .y1(d => y(d.upperCI));

      svg.append("path")
        .datum(data)
        .attr("fill", "lightblue")
        .attr("fill-opacity", 0.5)
        .attr("d", area);

      // Add the x-axis
      svg.append("g")
        .attr("transform", `translate(0,${height - margin.bottom})`)
        .call(d3.axisBottom(x));

      // Add the y-axis
      svg.append("g")
        .attr("transform", `translate(${margin.left},0)`)
        .call(d3.axisLeft(y));

      // add legend
      // Create a legend g element.
      const legend = svg.append("g")
        .attr("transform", `translate(${width - margin.right}, ${margin.top})`); // Position legend at top right corner

      const legendItems = [
        { color: "steelblue", label: "KM Curve" },
        // { color: "lightblue", label: "Confidence Interval" }
      ];

      legendItems.forEach((item, index) => {
        // Add colored squares for each item
        legend.append("rect")
          .attr("x", -100)
          .attr("y", index * 20)  // space each item 20 pixels apart
          .attr("width", 10)
          .attr("height", 10)
          .style("fill", item.color);

        // Add text labels for each item
        legend.append("text")
          .attr("x", -85) // Position text 15 pixels to the right of the square
          .attr("y", index * 20 + 9)  // this will vertically center text in relation to squares
          .text(item.label)
          .style("font-size", "12px")
          .attr("alignment-baseline", "middle");
      });

      // add x and y labels
      svg
        .append('text')
        .text('Time (days)')
        .style('font-family', 'Arial')
        // .style('font-weight', 'bold')
        .style('font-size', '1.2rem')
        .style('text-anchor', 'middle')
        .attr('x', width / 2)
        .attr('y', height);
      svg
        .append('text')
        .text('Survival Probability')
        .style('font-family', 'Arial')
        // .style('font-weight', 'bold')
        .style('font-size', '1.2rem')
        .style('text-anchor', 'middle')
        .attr('x', margin.left / 2 - 5)
        .attr('transform', `rotate(-90, ${margin.left / 2 - 5}, ${height / 2})`)
        .attr('y', height / 2);



    }
  }, [width, height, margin, props.selectedOption]);

  return (
    <Card p='20px' align='center' direction='column' w='100%' {...rest}>
      <div className="App">
        <h3>Overall Kaplan-Meier Curve</h3>
        <svg ref={ref} width="100%" viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="xMidYMid meet"></svg>
        {error && <p>{error}</p>} {/* Display error message */}
      </div>
    </Card>
  );
}
